const driversOnline = {
  driversOnline: 'Conductores en línea',

  table: {
    headers: {
      name: 'Nombre',
      phone: 'Número de teléfono',
      status: 'Estado',
      vehicle: 'Vehículo',
      activeSince: 'Activo desde',
      sum: 'Suma',
      pax: 'Pax',
      earned: 'Ganado',
    },
    driverStatusOptions: {
      online: 'En línea',
      enRoute: 'En Ruta',
      break: 'Descanso',
      endBreak: 'Fin de descanso',
    },
    actions: {
      deactivate: 'Suspender',
    },
  },

  form: {
    fields: {
      driver: 'Conductor',
      vehicle: 'Vehículo',
    },
    activateButton: 'Ir en línea',
  },

  deactivateModal: {
    header: 'Desactivar conductor',
    body: '¿Está seguro de que desea desactivar {{driver}}?',
  },
  breakModal: {
    header: 'Conductor de descanso',
    body: '¿Está seguro de que desea soltar a {{driver}} para un descanso?',
  },
};

export default driversOnline;
